export default __webpack_public_path__ + "static/media/folder_blue.7b923b1e.png";